// ============================================================
// BLACK OWL - API Configuration
// ============================================================
// URLs for Firebase Functions and the Cloud Run polling service.
// ============================================================

const BASE_URL = "https://us-central1-black-owl-app.cloudfunctions.net";
const POLLING_URL = "https://poll-service-271276966302.us-central1.run.app";

export async function apiCall(endpoint, body) {
  console.log("API Call:", endpoint, body);
  try {
    const res = await fetch(`${BASE_URL}/${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    const text = await res.text();
    console.log("API Response:", res.status, text);
    let data;
    try {
      data = JSON.parse(text);
    } catch {
      data = { error: text };
    }
    if (!res.ok) {
      throw new Error(data.error || data.message || `Request failed (${res.status})`);
    }
    return data;
  } catch (err) {
    console.log("API Error:", err);
    throw err;
  }
}

export async function pollingCall(endpoint, body) {
  console.log("Polling Call:", endpoint, body);
  try {
    const res = await fetch(`${POLLING_URL}/${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    console.log("Polling Response:", data);
    return data;
  } catch (err) {
    console.log("Polling Error:", err);
    throw err;
  }
}

export { POLLING_URL };
export default BASE_URL;
